import React from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import {
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Button,
    Divider,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAuth } from '../context/AuthContext';

const drawerWidth = 220;

const navItems = [
    { to: '/admin', label: 'Pulpit', icon: <DashboardIcon />, end: true },
    { to: '/admin/teams', label: 'Drużyny', icon: <GroupsIcon /> },
    { to: '/admin/seasons', label: 'Sezony', icon: <EmojiEventsIcon /> },
    { to: '/admin/news', label: 'Aktualności', icon: <ArticleIcon /> },
];

const AdminLayout = () => {
    const navigate = useNavigate();
    const { handleLogout } = useAuth();

    const onLogout = async () => {
        await handleLogout();
        navigate('/');
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                        Panel administracyjny — Średzka LZS
                    </Typography>
                    <Button color="inherit" onClick={onLogout}>
                        Wyloguj
                    </Button>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar />
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        {navItems.map((item) => (
                            <ListItemButton
                                key={item.to}
                                component={NavLink}
                                to={item.to}
                                end={item.end}
                                sx={{ '&.active': { bgcolor: 'action.selected' } }}
                            >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        ))}
                    </List>
                    <Divider />
                    <List>
                        <ListItemButton component={NavLink} to="/">
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                            <ListItemText primary="Strona publiczna" />
                        </ListItemButton>
                    </List>
                </Box>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout;
